export default __webpack_public_path__ + "media/images/images/portrait/small/avatar-s-12-96b94e668c3189a25d544a692cfbc389.png";